module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "uploader",
    staticClass: "dropzone"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82c863e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/Uploader.vue
// module id = 1150
// module chunks = 5